export default __webpack_public_path__ + "static/media/hot-14.464e97d7.png";